import { CURRENCY } from "../constants";

export default {
  getCurrentCurrency(store) {
    const currency = store.state.app.settings.currency;
    return CURRENCY[currency].symbol;
  },
  getCurrenctCurrencyUnit(store) {
    const currency = store.state.app.settings.currency;
    return CURRENCY[currency].unit;
  },
  transfer(vm, { from = "CNY", to = "", value, precision = 2 }) {
    const rateMap = vm.$store.state.market.rateMap;
    const currency = vm.$store.state.app.settings.currency;
    value = isNaN(Number(value)) ? 0 : Number(value);
    to = to.toUpperCase() || currency.toUpperCase();
    from = from.toUpperCase();
    const rf = from === "CNY" ? 1 : rateMap[from];
    const rt = to === "CNY" ? 1 : rateMap[to];
    const result = !(rf && rt) ? 0 : (rf * value) / rt;
    return result.toFixed(precision);
  },
  fiat(vm: Vue, { value, from, dispaly = "symbol", precision = 2 }) {
    const transfer = vm.$common.utils.currency.transfer;
    const currency = vm.$store.state.app.settings.currency;
    const symbol = CURRENCY[currency].symbol;
    const unit = CURRENCY[currency].unit;
    const result = transfer(vm, { from, to: currency, value, precision });
    const format = new Intl.NumberFormat(vm.$i18n.locale).format(
      Number(result)
    );
    switch (dispaly) {
      case "symbol":
        return `${symbol}${format}`;
      case "code":
        return `${unit}${format}`;
      case "none":
        return format;
    }
    return format;
  }
};
